import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
/// components
import { ProfileComponent } from './profile.component';
import { AuthGuard } from '@tesla/ng-auth';
import { UnSavedGuard } from '../shared/gaurds/unsaved.gaurd';
import { AddressComponent } from './components/address/address.component';
import { BankComponent } from './components/bank/bank.component';
import { OtherDocumentComponent } from './components/other-document/other-document.component';
import { PeopleComponent } from './components/people/people.component';
import { InternalComponent } from './components/internal/internal.component';
import { SiteComponent } from './components/site/site.component';
import { SoftwareComponent } from './components/software/software.component';
import { ToolEquipmentComponent } from './components/tool-equipment/tool-equipment.component';
import { LoanWheelInventoryComponent } from './components/loan-wheel-inventory/loan-wheel-inventory.component';
import { OtpGuard } from '../shared/services/otp/otp.guard';
import { SurveyComponent } from './components/onboarding/survey/survey.component';
import { DiversityComponent } from './components/diversity/diversity.component';
import { RemitToAddressComponent } from './components/address/tabs/remitto/remitto-address.component';
import { ManufacturingAddressComponent } from './components/address/tabs/manufacturing/manufacturing-address.component';
import { SupplierShipFromAddressComponent } from './components/address/tabs/supplier-ship-from/supplier-ship-from-address.component';
import { TaxComponent } from './components/tax/tax.component';
import { EhsQuestionnaireComponent } from './components/ehs-questionnaire/ehs-questionnaire.component';
import { EinvoicingChannelsComponent } from './components/einvoicing-channels/einvoicing-channels.component';
import { EdiStatusComponent } from './components/edi-status/edi-status.component';
import { OnboardingHomeComponent } from './components/task/onboarding-home/onboarding-home.component';
import { TaskComponent } from './components/task/task.component';
import { AddressTaskWrapperComponent } from './components/task/address-task-wrapper/address-task-wrapper.component';
import { ContactTaskWrapperComponent } from './components/task/contact-task-wrapper/contact-task-wrapper.component';
import { BankTaskWrapperComponent } from './components/task/bank-task-wrapper/bank-task-wrapper.component';
import { DiversityTaskWrapperComponent } from './components/task/diversity-task-wrapper/diversity-task-wrapper.component';
import { TaxTaskWrapperComponent } from './components/task/tax-task-wrapper/tax-task-wrapper.component';
import { HomePageGuard } from './guard/home-page.guard';

const createEditChildren: Routes = [
  { path: '', redirectTo: 'Address', pathMatch: 'full' },
  {
    path: 'Address',
    component: AddressComponent,
    canDeactivate: [UnSavedGuard],
    data: { tabName: 'Address' },
    children: [
      { path: '', redirectTo: 'RemitTo', pathMatch: 'full' },
      {
        path: 'RemitTo', // child route path
        component: RemitToAddressComponent, // child route component that the router renders
      },
      {
        path: 'Manufacturing',
        component: ManufacturingAddressComponent, // another child route component that the router renders
      },
      {
        path: 'manufacturing',
        component: ManufacturingAddressComponent, // another child route component that the router renders
      },
      {
        path: 'SupplierShipFromAddress',
        component: SupplierShipFromAddressComponent, // another child route component that the router renders
      },
    ]
  },
  { path: 'Site', component: SiteComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Site' } },
  { path: 'Contacts/:internal', component: PeopleComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Contacts/:internal' } },
  { path: 'Contacts', component: PeopleComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Contacts' } },
  { path: 'Tool', component: ToolEquipmentComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Tool' } },
  { path: 'Equipment', component: ToolEquipmentComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Equipment' } },
  { path: 'Software', component: SoftwareComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Software' } },
  { path: 'Internal', component: InternalComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Internal' } },
  { path: 'Document', component: OtherDocumentComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Document' } },
  { path: 'Loaner Wheel Inventory', component: LoanWheelInventoryComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'Loaner Wheel Inventory' } },
  { path: 'Bank', component: BankComponent, canDeactivate: [UnSavedGuard], canActivate: [OtpGuard], data: { tabName: 'Bank' } },
  { path: 'Diversity', component: DiversityComponent, data: { tabName: 'Diversity' } },
  { path: 'Tax', component: TaxComponent, canDeactivate: [], canActivate:[OtpGuard], data: { tabName: 'Tax' } },
  { path: 'EHS Questionnaire', component: EhsQuestionnaireComponent, canDeactivate: [UnSavedGuard], data: { tabName: 'EHS Questionnaire' } },
  { path: 'EInvoicing', component: EinvoicingChannelsComponent, data: {tabName: 'EInvoicing'}},
  { path: 'EDI Status', component: EdiStatusComponent, data: { tabName: 'EDI Status' } },
];

const taskFormChildren: Routes = [
  { path: 'Address', component: AddressTaskWrapperComponent },
  { path: 'AddressList', component: AddressTaskWrapperComponent },
  { path: 'Contacts', component: ContactTaskWrapperComponent },
  { path: 'Bank', component: BankTaskWrapperComponent },
  { path: 'Tax', component: TaxTaskWrapperComponent },
  { path: 'TaxList', component: TaxTaskWrapperComponent, canActivate: [OtpGuard], data: { isReactivation: true } },
  { path: 'Diversity', component: DiversityTaskWrapperComponent }
];

const routes: Routes = [
  {
    path: '', // Tesla auth
    pathMatch: 'full',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':code',
    component: ProfileComponent,
    canActivate: [AuthGuard],
    children: createEditChildren
  },
  {
    path: ':code/Onboarding/Survey',
    component: SurveyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':code/:flow/Home',
    component: OnboardingHomeComponent,
    canActivate: [AuthGuard, HomePageGuard],
    children: [
      {
        path: ':taskId',
        component: OnboardingHomeComponent
      }
    ]
  },
  {
    path: ':code/Task/:portalTaskId',
    component: TaskComponent,
    canActivate: [AuthGuard],
    children: taskFormChildren
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
